import axios from 'axios'
import NProgress from 'nprogress' // 引入nprogress插件
import 'nprogress/nprogress.css'  // 这个nprogress样式必须引入
//notification：通知提醒框
import { message, notification } from 'ant-design-vue'
import { VueAxios } from './vueAxios.js'

axios.defaults.withCredentials = true
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

//正式环境使用
  //../Api/
const baseUrl = location.href.toLowerCase().indexOf('localhost')!= -1 ? 'http://localhost:30081/' :'../Api/';

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: baseUrl,
  'Access-Control-Allow-Origin': '*',
  timeout: 300000, // 请求超时时间
})


// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    const data = error.response.data
    // 从 localstorage 获取 token
    //const token = storage.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      notification.error({
        message: '无使用此功能权限!',
        description: data.error
      })
      NProgress.done();
      //window.history.back();
    }
    if (error.response.status === 405) {
      notification.error({
        message: '登入时间已超时麻烦重新登入谢谢!',
        description: data.error
      })
      NProgress.done();
      setTimeout(function () {
        sessionStorage.clear();
        location.href = "/#/login"
      }, 2000);
    }
    if (error.response.status === 400) {
      notification.error({
        message: '请求异常,请先刷新页面或检查条件在使用,如有还有异常麻烦联系工程师谢谢!',
        description: data.error
      })
      NProgress.done();
      // setTimeout(function () {
      //   sessionStorage.clear();
      //   location.href = "/#/login"
      // }, 2000);
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      notification.error({
        message: 'Unauthorized',
        description: 'Authorization verification failed'
      })
      NProgress.done();
      //   if (token) {
      //     store.dispatch('Logout').then(() => {
      //       setTimeout(() => {
      //         window.location.reload()
      //       }, 1500)
      //     })
      //   }
    }
    if (error.response.status === 503) {
      notification.error({
        message: '系统升级中,短暂维护请稍待片刻,有问题请联系客服人员谢谢!',
        description: data.error
      })
      NProgress.done();
      setTimeout(function () {
        sessionStorage.clear();
        location.href = "/#/login"
      }, 2000);
    }
  }
  return Promise.reject(error)
}

// 请求拦截器
request.interceptors.request.use(config => {
  
  NProgress.start()

  config.headers['Access-Control-Allow-Origin'] = '*';
  
  //const token = storage.get(ACCESS_TOKEN)
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  //   if (token) {
  //     config.headers['Access-Token'] = token
  //   }
  return config
}, errorHandler)

// 响应拦截器
request.interceptors.response.use((response) => {
  //操作失败
  
  NProgress.done() 
  if (response.data.data === false) {
    message.error(response.data.error)
    return false
  }
  else if (response.config.responseType === 'blob') {
    
    return Promise.resolve({ data: response.data })
  }else {
    //成功返回
    return response.data
  }
}, errorHandler)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as VueAxios,
  request as axios
}



// WEBPACK FOOTER //
// ./src/js/request.js